import PropTypes from 'prop-types';
import { css } from '@emotion/react';

import { mobileOnly, setOpacity, tabletUp } from 'styles/utils';
import { colors } from 'styles/theme';

import { promosShape } from 'components/InfoCenter/InfoCenter.config';

import PromoCardsCta from '../PromoCardsCta/PromoCardsCta';
import PromoCardsTitle from '../PromoCardsTitle/PromoCardsTitle';

import PromoListGrid from './PromoListGrid';

const rootCss = removeCtaLink => css`
  display: grid;

  ${mobileOnly} {
    grid-template-areas: 'title' 'links' ${removeCtaLink ? '' : "'ctaLink'"};
    grid-row-gap: 20px;
  }

  ${tabletUp} {
    grid-template-columns: 70% 1fr;
    grid-template-areas: ${removeCtaLink ? "'title title'" : "'title ctaLink'"} 'links links';
    grid-row-gap: 42px;
  }
`;

const titleCss = css`
  grid-area: title;
  padding-bottom: 17px;
  border-bottom: 1px solid ${setOpacity(colors.inputBorder, 0.4)};
`;

const ctaCss = css`
  ${tabletUp} {
    border-bottom: 1px solid ${setOpacity(colors.inputBorder, 0.4)};
    padding-bottom: 17px;
  }
`;

function PromoList({ className, promos }) {
  return (
    <div css={rootCss(promos.removeCta)} className={className}>
      {/* Title */}
      {promos.title && <PromoCardsTitle text={promos.title} css={titleCss} />}

      {/* Call to action */}
      {!promos.removeCta && promos.ctaLinkHref && (
        <PromoCardsCta
          text={promos.ctaText}
          linkAs={promos.ctaLinkAs}
          linkHref={promos.ctaLinkHref}
          css={ctaCss}
        />
      )}

      {/* Promos */}
      <PromoListGrid articles={promos.articles} />
    </div>
  );
}

PromoList.propTypes = {
  className: PropTypes.string,
  promos: PropTypes.shape(promosShape),
};

export default PromoList;
